<template>
  <ProductList :items="loadingList" size="three-quarters" display-mode="grid">
    <template #card-footer>
      <LoadingSkeleton :class="$style['skeleton-button-primary']" />
      <LoadingSkeleton :class="$style['skeleton-button-secondary']" />
    </template>
  </ProductList>
</template>

<script setup lang="ts">
import {
  LoadingSkeleton,
  ProductList
} from '@hypercodestudio/basler-components';
import type { ProductCardProps } from '@hypercodestudio/basler-components/dist/components/modules/ProductCard.vue';

interface Props {
  itemCount?: number;
}

const props = withDefaults(defineProps<Props>(), {
  itemCount: 9
});

const loadingList = computed((): ProductCardProps[] => {
  const product = {
    product: {
      id: '',
      name: '',
      variantName: '',
      description: '',
      price: -1,
      priceText: '',
      pricePrefix: '',
      attributes: [
        {
          key: 'sensor',
          label: 'Sensor',
          value: ''
        },
        {
          key: 'framerate',
          label: 'Framerate',
          value: ''
        },
        {
          key: 'resolution',
          label: 'Auflösung (MP)',
          value: ''
        },
        {
          key: 'interface',
          label: 'Schnittstelle',
          value: ''
        },
        {
          key: 'sensorformat',
          label: 'Sensorformat',
          value: ''
        }
      ],
      media: {
        type: 'image',
        content: {
          src: '',
          width: 300,
          height: 225
        }
      }
    },
    isLoading: true,
    attributesLoadingLines: 5,
    loadingLines: 2
  };
  const skeletonProducts = [];
  for (let i = 0; i < props.itemCount; i++) {
    skeletonProducts.push(product);
  }
  return skeletonProducts;
});
</script>

<style module>
.skeleton-button-primary {
  border: 0 none;
  border-radius: 40px !important;
  padding: 12px 24px;
  height: 48px !important;
  width: 100% !important;
  margin-bottom: 12px;
}

.skeleton-button-secondary {
  border: 0 none;
  border-radius: 0 !important;
  padding: 8px 0;
  height: 24px !important;
  width: 60% !important;
  margin: 0 auto;
}
</style>
